export default __webpack_public_path__ + "static/media/dark.e139e037.svg";